import { useOnboardingContext } from "@/contexts/OnboardingContext";
import { useEffect, useState } from "react";
import OnboardingStepHeader from "../OnboardingStepHeader";
import CookingHabitsFollowUpStep from "./CookingHabitsFollowUpStep";

const CookingHabitsStep = ({
  stepData,
  handleContinue,
  cookingHabitsStepAnswers,
}: {
  stepData: any;
  handleContinue?: (answer?: any) => void;
  cookingHabitsStepAnswers: any[];
}) => {
  const {
    setUserAnswer,
    addDynamicStep,
    onboardingSteps,
    setCurrentStepIndex,
  } = useOnboardingContext();

  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [pendingStepKey, setPendingStepKey] = useState<string | null>(null);

  useEffect(() => {
    if (pendingStepKey) {
      const newIndex = onboardingSteps.findIndex(
        (step) => step.key === pendingStepKey
      );
      if (newIndex !== -1) {
        setCurrentStepIndex(newIndex);
        setPendingStepKey(null);
      }
    }
  }, [onboardingSteps, pendingStepKey, setCurrentStepIndex]);

  if (!stepData) return null;

  const handleSelect = (answer: any) => {
    setSelectedId(answer.id);
    setUserAnswer("cookingHabits", answer);

    const followUpKey = `cookingHabitsFollowUp-${answer.id}`;

    const followUpData = cookingHabitsStepAnswers.find((entry) =>
      entry.linkedCookingHabits?.some((linked: any) => linked.id === answer.id)
    );

    if (followUpData) {
      addDynamicStep({
        key: followUpKey,
        isSkippable: false,
        isFollowUpStep: true,
        image: followUpData?.linkedOptionImages?.[0],
        component: () => (
          <CookingHabitsFollowUpStep
            stepData={followUpData}
            handleContinue={handleContinue}
          />
        ),
      });

      // Save key so we can jump once it's injected
      setPendingStepKey(followUpKey);
    }

    handleContinue && handleContinue(answer);
  };

  return (
    <div className="mx-auto flex w-full max-w-lg flex-1 flex-col justify-center md:pl-10 lg:justify-center">
      <OnboardingStepHeader
        heading={stepData.heading}
        headingDataPosthog="onboarding-cooking-habits-heading"
      />

      <div className="space-y-2">
        {stepData.cookingHabitsSelection?.map((answer: any) => {
          const isSelected = selectedId === answer.id;

          return (
            <button
              key={answer.id}
              onClick={() => handleSelect(answer)}
              className={`w-full rounded-full border px-6 py-2 text-left font-body text-sm text-black transition md:text-base ${
                isSelected
                  ? "border-zinc-300 bg-zinc-100"
                  : "border-zinc-300 hover:bg-zinc-100"
              }`}
              data-posthog={`onboarding-cooking-habits-option`}
            >
              {answer.title}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CookingHabitsStep;
